import './blog.css';
import { Header } from "../../components/widgets/header/header";
import { Posts } from "../../components/widgets/posts/posts";
import { smoothScroll } from "../index/smooth-scroll";

export function initBlogPage() {
  Header.init();
  smoothScroll.init();
  Posts.init();
}